<div class="edit-container">
    <h1 class="edit-title">Actualizează Categorie Template</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Nume</mat-label>
                    <input type="text" matInput formControlName="name" />
                    <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Descriere</mat-label>
                    <textarea type="text" matInput formControlName="description" rows="3"></textarea>
                    <mat-error *ngIf="!form.controls['description'].valid && form.controls['description'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>


        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Direcție</mat-label>
                    <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                        (selectionChange)="onDirectieChange($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                            {{ directie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['directie_id'].valid && form.controls['directie_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Compartiment</mat-label>
                    <mat-select formControlName="compartiment_id" (openedChange)="onCompartimentSelectClosed()"
                        (selectionChange)="onCompartimentChange($event.value)">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="compartimenteControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                        <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Categorie Părinte</mat-label>
                    <mat-select (openedChange)="onParentCategoriesSelectClosed()" formControlName="parent_category_id">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="parentCategoriesControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredParentCategories.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let category of filteredParentCategories" [value]="category.id">
                            {{ category.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="form-text mb-3">
                    <i class="fas fa-exclamation-triangle text-warning me-1"></i>
                    <strong>Atenție:</strong> Modificarea categoriei părinte poate afecta structura existentă.
                </div>
            </div>
        </div>

        <div class="col-md-12">
            <mat-form-field class="w-100" appearance="fill">
                <mat-label>Index Ordine</mat-label>
                <input type="number" matInput formControlName="order_index" min="0">
                <mat-error *ngIf="!form.controls['order_index'].valid && form.controls['order_index'].touched">
                    Câmp obligatoriu
                </mat-error>
            </mat-form-field>
        </div>

        <div class="row mt-4">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>